import { alpsLogoLogin, closeGrey, error, ssoButton, success } from "../../../app/icons";
import styled, { keyframes } from "styled-components";

export const StyledMainWrapper = styled.div`
    background: #f6f9fd;
    margin: 0;
    padding: 0;
    height: 100vh;
    width: 100vw;
    position: relative;
    z-index: 1;
`;

export const StyledLoginPage = styled.div`
    font-size: 62.5%;
    box-sizing: border-box;

    @media (min-width: 2100px) {
        font-size: 100%;
    }

    @media (max-width: 2100px) {
        font-size: 90.5%;
    }

    @media (max-width: 2000px) {
        font-size: 85.5%;
    }

    @media (max-width: 1900px) {
        font-size: 78.5%;
    }

    @media (max-width: 1800px) {
        font-size: 76.5%;
    }

    @media (max-width: 1600px) {
        font-size: 69.5%;
    }

    @media (max-width: 1400px) {
        font-size: 63.5%;
    }
`;

export const StyledLoginPageContent = styled.div`
    border: none;
    width: 107.8em;
    margin: 0 auto;
    border-radius: 5px;
    height: ${(props: { passField: boolean }) => (props.passField ? "72.2em" : "56.2em")};
    position: fixed;
    top: 50%;
    left: 49%;
    transform: translate(-50%, -50%);
    display: flex;
    box-sizing: border-box;
`;

export const StyledLoginFormOuterContainer = styled.div`
    width: 48%;
    box-sizing: border-box;
`;

export const StyledLoginFormContainer = styled.div`
    margin: 5.9em;
    height: 83%;
    background: #fff;
    border-radius: 1em;
    position: relative;
    box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
`;

export const StyledLoginFormAlpsLogo = styled.div`
    padding: 30px;
    box-sizing: border-box;
    box-sizing: border-box;
`;

export const StyledAlpsLogo = styled.a`
    background: url(${alpsLogoLogin}) no-repeat;
    pointer-events: none;
    background-size: 11em;
    display: block;
    background-position-x: 48%;
    text-align: center;
    width: 100%;
    height: 3em;
    box-sizing: border-box;
`;

export const StyledLoginFormHeader = styled.h3`
    font-family: Poppins;
    font-size: 2.55em;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    margin-top: 0.2em;
    margin-bottom: ${(props: { showErrMsg: boolean }) => (props.showErrMsg ? "0.5em" : "1em")};
    color: rgb(51, 51, 51);
`;

export const StyledFormLoginContentContainer = styled.div`
    padding: 0 3.15em;
    box-sizing: border-box;
`;

export const StyledLoginForm = styled.form`
    zoom: 1; /* IE < 8 */

    &:before,
    &:after {
        content: ".";
        display: block;
        height: 0;
        overflow: hidden;
        vertical-align: top; /* to align box at the top */
    }
    &:after {
        clear: both;
    }
    box-sizing: border-box;
`;

export const StyledEmailField = styled.p`
    width: 100%;

    &::-webkit-input-placeholder {
        font-size: 16px;
    }

    &::-moz-placeholder {
        font-size: 16px;
    }

    &:-ms-input-placeholder {
        font-size: 16px;
    }

    &:-moz-placeholder {
        font-size: 16px;
    }
    box-sizing: border-box;
`;

export const StyledLoginInput = styled.input`
    font-family: Lato;
    width: 100%;
    border: solid 1px #afafaf;
    border-radius: 0.3em;
    color: #394961;
    &::-webkit-autofill {
        -webkit-background-clip: text;
    }
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.33;
    height: 46px;
    box-sizing: border-box;
    box-sizing: border-box;
`;

export const StyledPassField = styled.p`
    width: 100%;
    padding: 2.5em 0 2em 0;

    &::-webkit-input-placeholder {
        font-size: 16px;
    }

    &::-moz-placeholder {
        font-size: 16px;
    }

    &:-ms-input-placeholder {
        font-size: 16px;
    }

    &:-moz-placeholder {
        font-size: 16px;
    }
    box-sizing: border-box;
`;

export const StyledForgotPass = styled.div`
    text-align: right;
    padding: 1em 0;
    box-sizing: border-box;
`;

export const StyledForgotPassAnchor = styled.a`
    text-decoration: underline;
    font-family: Poppins;
    font-size: 1.4em;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #394961;
    box-sizing: border-box;
`;

export const StyledLoginButtonContainer = styled.div`
    padding: 1.5em 0;
    box-sizing: border-box;
`;

export const StyledButtonContainer = styled.div`
    padding: 2.5em 0;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

export const StyledLoginButton = styled.button`
    min-height: 2.85em;
    position: relative;
    background: linear-gradient(270deg, rgb(248, 173, 73) 0px, rgb(241, 116, 76) 100%);
    box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, 0.16);
    border: none;
    border-radius: 0.3em;
    font-size: 14px;
    font-family: 'Poppins';
    font-stretch: normal;
    font-style: normal;
    display: block;
    width: 100%
    padding: 10px 16px;
    line-height: 1.33;
    color: #fff;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "not-allowed" : "pointer")};
    user-select: none;
    opacity: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "0.7" : "1")};
    & span {
        font-weight: 500;
    }
`;

export const StyledSSOButton = styled.button`
    min-height: 2.85em;
    position: relative;
    background: url(${ssoButton}) no-repeat;
    border: none;
    border-radius: 0.3em;
    font-size: 14px;
    font-family: 'Poppins';
    font-stretch: normal;
    font-style: normal;
    display: block;
    width: 100%
    padding: 10px 16px;
    line-height: 1.33;
    color: #fff;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "not-allowed" : "pointer")};
    user-select: none;
    opacity: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "0.7" : "1")};
    & span {
        font-weight: 500;
    }
    top: 2%;
    background-position: center;
`;

export const StyledSeparateSSOButton = styled.button`
    min-height: 2.85em;
    position: relative;
    background: url(${ssoButton}) no-repeat;
    background-position: center;
    border: none;
    border-radius: 0.3em;
    font-size: 14px;
    font-family: 'Poppins';
    font-stretch: normal;
    font-style: normal;
    display: block;
    width: 100%
    padding: 10px 16px;
    line-height: 1.33;
    color: #fff;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "not-allowed" : "pointer")};
    user-select: none;
    opacity: ${(props: { loggingIn: boolean }) => (props.loggingIn ? "0.7" : "1")};
    & span {
        font-weight: 500;
    }
`;

export const StyledPassButton = styled.button`
    min-height: 2.85em;
    position: relative;
    background: linear-gradient(270deg, rgb(248, 173, 73) 0px, rgb(241, 116, 76) 100%);
    box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, 0.16);
    border: none;
    border-radius: 0.3em;
    font-size: 13px;
    font-family: 'Poppins';
    font-stretch: normal;
    font-style: normal;
    display: block;
    width: ${(props: { btn_type: string }) => (props.btn_type === "login" ? "84%" : "100%")};
    padding: 10px 16px;
    line-height: 1.33;
    color: #fff;
    margin-bottom: 0;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    opacity: 1;
    & span {
        font-weight: 500;
    }
`;

const loaderImage = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
    box-sizing: border-box;
`;

const webkitLoaderImage = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
    box-sizing: border-box;
`;

const mozLoaderImage = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
    box-sizing: border-box;
`;

export const StyledLoginLoaderImage = styled.img`
    display: inline-block;
    width: 27px;
    position: absolute;
    top: 14%;
    right: 47%;
    -webkit-animation: ${webkitLoaderImage} 0.75s linear infinite;
    -moz-animation: ${mozLoaderImage} 0.75s linear infinite;
    animation: ${loaderImage} 0.75s linear infinite;
    box-sizing: border-box;
`;

export const StyledContactUsForm = styled.div`
    position: absolute;
    bottom: 2.2em;
    left: 40%;
    box-sizing: border-box;
`;

export const StyledContactUsAnchor = styled.a`
    font-family: Poppins;
    font-size: 1.46em;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.5;
    letter-spacing: normal;
    color: #fb764b;
    text-decoration: underline;
    box-sizing: border-box;
`;

export const StyledIHS = styled.div`
    width: 52%;
    box-sizing: border-box;
`;

export const StyledIHC = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10em 0 0 0;
    height: 83%;
    border-radius: 1em;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledIHH = styled.div`
    width: 96%;
    font-family: Poppins;
    font-size: 1.82em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: center;
    color: #394961;
    box-sizing: border-box;
`;

export const StyledIH = styled.div`
    margin-top: 2.47em;
    margin-bottom: 1.7em;
    text-align: center;
    font-family: Poppins;
    font-size: 1.74em;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.25;
    color: #394961;
    letter-spacing: normal;
    box-sizing: border-box;
`;

export const StyledCarousel = styled.div`
    width: 87%;
    display: flex;
    margin: 0 auto;
    flex-wrap: wrap;
    min-height: 24.2em;
    box-sizing: border-box;
`;

export const StyledLeftArrow = styled.button`
    color: ${(props: { disabled: boolean }) => (props.disabled ? "#afafaf" : "#343434")};
    cursor: ${(props: { disabled: boolean }) => (props.disabled ? "not-allowed" : "pointer")};
    box-sizing: border-box;
`;

export const StyledCarouselBody = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    box-sizing: border-box;
`;

export const StyledCarouselImage = styled.img`
    background-size: contain;
    height: 11.45em;
    margin-left: 1.3em;
    width: 21.95em;
    margin-top: -0.4em;
`;

export const StyledLoginErrorToast = styled.div`
    background: #fee4db;
    border: 0.1em solid #fb764b;
    max-width: 40rem;
    min-height: 2.25rem;
    padding: 0.2rem 0;
    box-sizing: border-box;
    border-radius: 0.3em;
    display: flex;
    margin-bottom: 2em;
`;
export const StyledChangesPasswrodToast = styled.div`
    background-color: #def9ea;
    border: 0.1em solid #53d68a;
    max-width: 40rem;
    min-height: 2.25rem;
    padding: 0.2rem 0;
    box-sizing: border-box;
    border-radius: 0.3em;
    display: flex;
    margin-bottom: 2em;
`;


export const StyledErrorToastHighlight = styled.span`
    background: #fb764b;
    margin: 0 0.2em 0 0.3em;
    width: 0.22em;
    min-height: 2em;
    overflow: hidden;
`;
export const StyledChangesPasswrodToastHighlight = styled.span`
    background: #53d68a;
    margin: 0 0.2em 0 0.3em;
    width: 0.22em;
    min-height: 2em;
    overflow: hidden;
`;


export const StyledErrorToastContent = styled.div`
    display: flex;
    align-items: center;
    width: 97%;
`;

export const StyledErrorToastIcon = styled.i`
    background: url(${error}) no-repeat;
    width: 1.5rem;
    height: 1rem;
    margin-left: 0.2em;
`;
export const StyledChangesPasswrodToastIcon = styled.i`
    background: url(${success}) no-repeat;
    width: 1.5rem;
    height: 1rem;
    margin-left: 0.2em;
`;

export const StyledErrorToastMsg = styled.span`
    box-sizing: border-box;
    font-size: 1.1em;
    color: #343434;
    float: left;
    line-height: 1rem;
    margin: 0.075rem 0 0 0.1em;
    overflow-wrap: break-word;
    overflow: hidden;
    width: 100%;
    padding: 0 0 0.2em 0;
`;
export const StyledChangepasswrodMsg = styled.span`
    box-sizing: border-box;
    font-size: 1.1em;
    color: #343434;
    float: left;
    line-height: 1rem;
    margin: 0.075rem 0 0 0.1em;
    overflow-wrap: break-word;
    overflow: hidden;
    width: 100%;
    padding: 0 0 0.2em 1em;
`;

export const StyledErrorToastRemoveIcon = styled.i`
    background: url(${closeGrey}) no-repeat;
    cursor: pointer;
    width: 1.6em;
    height: 1em;
`;

export const StyledSeparator = styled.p`
    display: flex;
    align-items: center;
    font-size: 13px;
    margin: 10px 0;

    &:before,
    &:after {
        content: "";
        flex-grow: 1;
        height: 1px;
        background-color: #EBEBEB;
    }
    &:after {
        margin-left: 10px;
    }
`;
